import $ from 'jquery';

const ACTIVE = 'active';
const MENUACTIVE = 'menu-active';
const menu = () => {
  const nav = $('.c-main-nav');
  const $body = $('body');

  if (nav && nav.length) {
    const toggle = nav.find('.c-main-nav__toggle');
    toggle.click(() => {
      if ($body.hasClass(MENUACTIVE)) {
        $body.addClass('hide-menu');
        setTimeout(() => {
          $body.removeClass('menu-active hide-menu');
        }, 350);
      } else {
        $body.addClass(MENUACTIVE);
      }
    });

    const searchToggle = nav.find('.c-main-nav__search .c-main-nav__link');
    const searchMain = nav.find('#search');
    if (searchToggle && searchToggle) {
      searchToggle.click(ev => {
        ev.preventDefault();
        searchMain.toggleClass(ACTIVE);
      });
    }

    const modelSearchToggle = nav.find('[href="#model-search"]');
    const modelSearchMain = nav.find('#model-search');
    if (modelSearchToggle && modelSearchToggle) {
      modelSearchToggle.click(ev => {
        ev.preventDefault();
        modelSearchMain.toggleClass(ACTIVE);
      });
    }

    const closeSearch = nav.find('.c-main-nav__search-close');
    if (closeSearch && closeSearch.length) {
      closeSearch.click(ev => {
        const $self = $(ev.target);
        $self.parent().removeClass(ACTIVE);
      });
    }
  }
};
export default menu;



// WEBPACK FOOTER //
// ./src/scripts/modules/menu.js